import { Component, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertController, Platform } from '@ionic/angular';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthService } from './shared/services/auth.service';
import { UserPayload } from './models/user-payload.model';
import { UserService } from './services/user/user.service';
import { UtilityService } from './services/utility/utility.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent implements OnInit {

  public isAuthenticated: boolean = false;
  public userPayload: UserPayload = { Email: '' };

  constructor(
    private swUpdate: SwUpdate,
    public router: Router,
    private permissionsService: NgxPermissionsService,
    public alertController: AlertController,
    private userService: UserService,
    private auth: AuthService,
    private utilityService: UtilityService,
  ) {
    this.checkVersionUpdates();
  }

  public async ngOnInit() {
    await this.auth.waitForMsalReady();
    const isAuthenticated = this.auth.isAuthenticated();
    if (isAuthenticated) {
      if (this.auth.isUserInfoAvailableInLocalStorage()) {
        this.auth.loadPermissionsFromStorage();
        this.auth.setPermissionsLoaded(true);
      } else {
        this.userPayload.Email = this.auth.getUserEmail();
        this.userService.saveUserInfo(this.userPayload).subscribe((data) => {
          if (data) {
            this.utilityService.setUserInfo(data);
            this.userService.getUserPermission().subscribe((permissions) => {
              if (permissions) {
                localStorage.setItem("userPermission", JSON.stringify(permissions));
                this.permissionsService.loadPermissions(permissions);
                this.auth.setPermissionsLoaded(true);
              }
            });
          }
        });
      }
    }
  }

  public checkVersionUpdates() {
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      map(evt => ({
        type: 'UPDATE_AVAILABLE',
        current: evt.currentVersion,
        available: evt.latestVersion,
      }))).subscribe((rs) => {
        if (rs.type == 'UPDATE_AVAILABLE') {
          this.alertController.create({
            header: `Digital Dull Grading: Loading New Version`,
            buttons: [
              {
                text: 'OK',
                handler: () => {
                  window.location.reload();
                }
              },
            ],
            backdropDismiss: false,
          }).then(res => {
            res.present();
          });
        }
      });
  }
}